import n from "./header-navigation-horizontal.vue.js";
import s from "./header-navigation-vertical.vue.js";
import { createBlock as l, openBlock as d, resolveDynamicComponent as m, createSlots as c, renderList as v, withCtx as p, renderSlot as u, normalizeProps as y, guardReactiveProps as f } from "vue";
/* empty css                       */
import O from "../../../_virtual/_plugin-vue_export-helper.js";
import h from "../../../utils/mixins/theme/theme.vue.js";
const S = {
  name: "DsHeaderNavigation",
  components: { DsHeaderNavigationHorizontal: n, DsHeaderNavigationVertical: s },
  mixins: [h],
  inject: ["updateHeaderFreezeTransition"],
  props: {
    /**
     * Screen size based on breakpoints
     */
    screen: { type: String, required: !0 },
    /**
     * Navigation primary items
     */
    primaryItems: {
      type: Array,
      default: () => [],
      validator: (e) => e.every((t) => typeof t == "object" && ["id", "title"].every((i) => i in t))
    },
    /**
     * Navigation secondary items
     */
    secondaryItems: {
      type: Array,
      default: () => [],
      validator: (e) => e.every((t) => typeof t == "object" && ["title", "url", "openInNewWindow", "nuxt"].every((i) => i in t))
    },
    /**
     * Navigation cta item
     */
    ctaItem: {
      type: Object,
      default: null,
      validator: (e) => ["title", "url", "openInNewWindow", "nuxt"].every((t) => t in e)
    },
    /**
     * Navigation labels
     */
    labels: {
      type: Object,
      required: !0,
      validator: (e) => ["ariaLabelNavigation", "ariaLabelOpenNavigation", "ariaLabelCloseNavigation"].every((t) => t in e)
    }
  },
  data: () => ({
    isSlideOverOpened: !1,
    savedScrollPosition: null
  }),
  computed: {
    navigationComponentName() {
      return this.screen === "large" ? "DsHeaderNavigationHorizontal" : "DsHeaderNavigationVertical";
    }
  },
  methods: {
    onSlideOverOpened() {
      this.updateHeaderFreezeTransition(!0), this.screen === "small" && (this.savedScrollPosition = typeof window < "u" ? window.scrollY : 0, document.body.classList.add("body-slide-over-open"));
    },
    onSlideOverClosed() {
      document.body.classList.remove("body-slide-over-open"), this.screen === "small" && typeof window < "u" && window.scrollTo({ left: 0, top: this.savedScrollPosition }), setTimeout(() => {
        this.screen === "small" && (this.savedScrollPosition = null), this.updateHeaderFreezeTransition(!1);
      }, 100);
    }
  }
};
function b(e, t, i, g, w, r) {
  return d(), l(m(r.navigationComponentName), {
    screen: i.screen,
    theme: e.theme,
    "primary-items": i.primaryItems,
    "secondary-items": i.secondaryItems,
    "cta-item": i.ctaItem,
    labels: i.labels,
    onSlideOverOpened: r.onSlideOverOpened,
    onSlideOverClosed: r.onSlideOverClosed
  }, c({ _: 2 }, [
    v(e.$slots, (N, a) => ({
      name: a,
      fn: p((o) => [
        u(e.$slots, a, y(f(o)))
      ])
    }))
  ]), 1064, ["screen", "theme", "primary-items", "secondary-items", "cta-item", "labels", "onSlideOverOpened", "onSlideOverClosed"]);
}
const L = /* @__PURE__ */ O(S, [["render", b]]);
export {
  L as default
};
